import {useParams} from 'react-router-dom';
import {useFetchCompleteList} from '../../../../../../../hooks/fetch-all-items';
import {EntityActivitiesRepository} from '../../../../../../../repositories/entity-activities';

export function useFetchActivitiesGroup(activitiesSectorId: string) {
  const {entityId} = useParams<{entityId: string}>();
  const {items, isLoading, error} = useFetchCompleteList({
    fetchFunction: () => {
      return EntityActivitiesRepository.instance.getAllGroups(entityId, activitiesSectorId);
    },
    deps: [entityId, activitiesSectorId],
  });

  return {
    items,
    isLoading,
    error,
  };
}
